// histogram-cache.ts — module-level 5-min TTL cache for the 24h
// volume histogram query. Same slice fired 3-5 times per operator
// session previously re-scanned GCS every time. Cache hit returns
// instantly + zero scan cost. FIFO-bounded to 100 entries.

const HISTOGRAM_CACHE_MAX = 100;

export class HistogramCache {
  private map = new Map<string, { rows: Array<{ ts: number; count: number }>; at: number }>();
  get(key: string): { rows: Array<{ ts: number; count: number }>; at: number } | undefined {
    return this.map.get(key);
  }
  set(key: string, value: { rows: Array<{ ts: number; count: number }>; at: number }): void {
    if (this.map.size >= HISTOGRAM_CACHE_MAX) {
      const firstKey = this.map.keys().next().value;
      if (firstKey) this.map.delete(firstKey);
    }
    this.map.set(key, value);
  }
}

export const histogramCache = new HistogramCache();
